module.exports = __webpack_public_path__ + "media/images/background_03-088f925735a63df65db32b0d1f66969b.jpg";